;(function(){
	var
	_AELS=!!document.addEventListener,
	_AEL=_AELS?"addEventListener":"attachEvent",
	_AELP=_AELS?"":"on",
	$html=document.querySelector("html"),
	mainLoaded=false,
	loadMain=function(){
		if(mainLoaded||document.readyState=="loading")
			return false;
		main();
		return mainLoaded=true;
	},
	applyToEach=function(selector,fn,args){
		var elements=document.querySelectorAll(selector);
		for(var i=0;i<elements.length;i++)
			fn.call(elements[i],args);
	},
	addClass=
		(document.body.classList)?
			function($el,className){
				$el.classList.add(className);
			}
		:
			function($el,className){
				$el.className+=" "+className;
			},
	removeClass=
		(document.body.classList)?
			function($el,className){
				$el.classList.remove(className);
			}
		:
			function($el,className){
				$el.className=$el.className.replace(new RegExp("(^|\\b)"+className+"(\\b|$)","gi"),"");
			},
	main=function(){
		applyToEach(".product__purchaseOpt",function(){
			var
			disabledValue="0",
			$select=this.querySelector("select"),
			$button=this.querySelector("input"),
			onChange=function(){
				$button.disabled=$select.value===disabledValue;
			};
// 			$select.value=disabledValue;
			onChange();
			$select[_AEL](_AELP+"change",onChange);
		});
	};
	
	removeClass($html,"no-js");
	addClass($html,"js");

	loadMain()||document[_AEL](_AELS?"DOMContentLoaded":"onreadystatechange",loadMain);
})();